// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
// import '@/styles/index.scss' -- 先注释

// 全局注释
// Vue.prototype.$baseUrl = 'https://www.yuniuerp.com:7444'
Vue.prototype.$baseUrl = process.env.NODE_ENV === 'production' ? 'https://www.yuniuerp.com/api' : ''

Vue.config.productionTip = false
Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js